// extracted by mini-css-extract-plugin
export var wrap = "j_m";
export var heading = "j_n";
export var prev = "j_p";
export var logo = "j_q";
export var title = "j_r";
export var twitter = "j_s";
export var icon = "j_t";
export var content = "j_v";
export var text = "j_w";